import React, { createContext, useState, useEffect } from 'react';
import api from '../api.js';

export const CSRFContext = createContext();

export function CSRFProvider({ children }) {
    const [csrfToken, setCsrfToken] = useState(null);

    useEffect(() => {
        const fetchCSRF = async () => {
            try {
                const { data } = await api.get('csrf-token');
                setCsrfToken(data.csrfToken);
            } catch (err) {
                console.error('Failed to fetch CSRF token:', err);
            }
        };
        fetchCSRF();
    }, []);

    return (
        <CSRFContext.Provider value={{ csrfToken }}>
            {children}
        </CSRFContext.Provider>
    );
}
